<template>
    <div class="min-h-screen bg-gray-50 flex flex-col items-center justify-center px-4 py-12">
        <!-- Logo -->
        <div class="mb-8 animate-fade-in">
            <img src="../assets/images/logo-light.png" alt="Resort Eco Business" class="h-14 object-contain" />
        </div>

        <!-- Card -->
        <div class="bg-white rounded-2xl shadow-lg w-full max-w-sm p-8 text-center animate-slide-up">
            <!-- Ícone de cadeado -->
            <div class="inline-flex items-center justify-center w-20 h-20 rounded-full bg-green-50 mb-6">
                <svg xmlns="http://www.w3.org/2000/svg" class="w-10 h-10" style="color: #527236;" fill="none"
                    viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                </svg>
            </div>

            <h1 class="text-2xl font-bold text-gray-900 mb-2">Redefinição de Senha</h1>

            <!-- Estado: Abrindo app -->
            <div v-if="estado === 'abrindo'">
                <p class="text-gray-500 mb-6 text-sm leading-relaxed">
                    Abrindo o aplicativo <strong>Resort Eco Business</strong>…
                </p>
                <div class="flex justify-center mb-6">
                    <div class="w-8 h-8 border-4 border-green-100 border-t-primary rounded-full animate-spin"
                        style="border-top-color: #527236;"></div>
                </div>
                <p class="text-xs text-gray-400 mb-4">
                    Se o aplicativo não abrir automaticamente, clique no botão abaixo.
                </p>
                <a :href="deepLinkUrl" class="block w-full py-3 px-6 text-white font-semibold rounded-xl transition"
                    style="background-color: #527236;" @click="abrirApp">
                    Abrir no Aplicativo
                </a>
            </div>

            <!-- Estado: Fallback (app não instalado) -->
            <div v-if="estado === 'fallback'">
                <p class="text-gray-500 mb-6 text-sm leading-relaxed">
                    Para redefinir sua senha, você precisa do aplicativo <strong>Resort Eco Business</strong>.
                </p>

                <p class="text-xs text-gray-400 mb-5">Baixe o aplicativo gratuitamente:</p>

                <!-- Botão Play Store -->
                <a :href="playStoreUrl" target="_blank" rel="noopener noreferrer"
                    class="flex items-center justify-center gap-3 w-full py-3 px-4 mb-3 bg-gray-900 hover:bg-gray-800 text-white rounded-xl transition font-medium">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="w-5 h-5 fill-white">
                        <path
                            d="M3.18 23.76c.3.17.64.24.99.2l12.44-11.72L13 8.62zM.29 1.6A1.5 1.5 0 000 2.5v19a1.5 1.5 0 00.29.9l.1.1 10.64-10.63v-.25L.4 1.5zM20.12 10.3l-2.97-1.68-3.37 3.37 3.37 3.38 2.99-1.7a1.5 1.5 0 000-3.37zM4.17.24L16.61 11.96l-3.62-3.62L4.18.22z" />
                    </svg>
                    <span>Google Play</span>
                </a>

                <!-- Botão App Store -->
                <a :href="appStoreUrl" target="_blank" rel="noopener noreferrer"
                    class="flex items-center justify-center gap-3 w-full py-3 px-4 bg-gray-900 hover:bg-gray-800 text-white rounded-xl transition font-medium">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="w-5 h-5 fill-white">
                        <path
                            d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
                    </svg>
                    <span>App Store</span>
                </a>

                <div class="mt-6 pt-5 border-t border-gray-100">
                    <p class="text-xs text-gray-400">
                        Já tem o aplicativo?
                        <button @click="tentarAbrirApp" class="font-medium" style="color: #527236;">
                            Tentar abrir novamente
                        </button>
                    </p>
                </div>
            </div>

            <!-- Estado: Token inválido -->
            <div v-if="estado === 'token-invalido'">
                <div class="inline-flex items-center justify-center w-14 h-14 rounded-full bg-red-50 mb-4">
                    <svg xmlns="http://www.w3.org/2000/svg" class="w-7 h-7 text-red-500" fill="none" viewBox="0 0 24 24"
                        stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M12 9v2m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
                    </svg>
                </div>
                <p class="text-gray-500 text-sm leading-relaxed">
                    Este link de recuperação é <strong>inválido ou expirou</strong>. Solicite um novo link pelo
                    aplicativo.
                </p>
            </div>
        </div>

        <!-- Rodapé -->
        <p class="mt-8 text-xs text-gray-400 text-center">
            © {{ anoAtual }} Resort Eco Business. Todos os direitos reservados.
        </p>
    </div>
</template>

<script>
export default {
    name: 'RecuperarSenhaApp',
    data() {
        return {
            estado: 'abrindo',
            token: '',
            anoAtual: new Date().getFullYear(),
            playStoreUrl: 'https://play.google.com/store/apps/details?id=com.resortecobusiness.resort_app',
            appStoreUrl: 'https://apps.apple.com/app/resort-eco-business/id0000000000',
        };
    },
    computed: {
        deepLinkUrl() {
            return `https://resortecobusiness.com.br/recuperar-senha?token=${this.token}`;
        },
    },
    mounted() {
        this.token = this.$route.query.token || '';

        if (!this.token) {
            this.estado = 'token-invalido';
            return;
        }

        this.tentarAbrirApp();
    },
    methods: {
        tentarAbrirApp() {
            this.estado = 'abrindo';

            // Tenta redirecionar para o deep link (App Links / Universal Links)
            // O Android/iOS irá interceptar e abrir o app se estiver instalado
            const url = this.deepLinkUrl;

            // Fallback após 2.5 segundos se o app não abriu
            const timeout = setTimeout(() => {
                this.estado = 'fallback';
            }, 2500);

            // No iOS usamos iframe trick; no Android, tentamos o intent
            const userAgent = navigator.userAgent || '';
            const isAndroid = /android/i.test(userAgent);
            const isIOS = /iphone|ipad|ipod/i.test(userAgent);

            if (isAndroid) {
                // Android: intent URL abre o app ou vai para Play Store
                const intentUrl =
                    `intent://recuperar-senha?token=${this.token}` +
                    `#Intent;scheme=https;host=resortecobusiness.com.br;` +
                    `package=com.resortecobusiness.resort_app;` +
                    `S.browser_fallback_url=${encodeURIComponent(url)};end`;

                window.location.href = intentUrl;

                // Limpa o timeout pois o Android gerencia o fallback via intent
                setTimeout(() => clearTimeout(timeout), 100);
                setTimeout(() => { this.estado = 'fallback'; }, 3000);
            } else if (isIOS) {
                // iOS: Universal Links são tratados pelo OS automaticamente
                // Se chegou nesta página, o app não está instalado
                clearTimeout(timeout);
                this.estado = 'fallback';
            } else {
                // Desktop/outro: mostra fallback
                clearTimeout(timeout);
                this.estado = 'fallback';
            }
        },
        abrirApp() {
            window.location.href = this.deepLinkUrl;
        },
    },
};
</script>
